import { createI18n } from "vue-i18n";
import locales from "./app-assets/data/locales";

export function loadLocaleMessages() {
  const messages = {};

  for (let key in locales) {
    messages[key] = locales[key];
  }
  
  return messages;
}

export function languageSelector() {
  let lan;
  let lang = localStorage.getItem("defaultLanguage");
  if (lang == "English") {
    lan = "en";
  }
  if (lang == "Polish") {
    lan = "pl";
  }
  if (lang == "Arabic") {
    lan = "ar";
  }
  return lan;
}

export default createI18n({
  locale: languageSelector(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
});
